// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2Pcr6","list":"PatternAutocomplete_list__3Ev7Y"};